export const HARDWARE_SCAN_MAX_GAP_MS = 140;
export const HARDWARE_SCAN_IDLE_COMMIT_MS = 180;
export const HARDWARE_SCAN_MIN_LENGTH = 4;

export function createHardwareScanState() {
  return { buffer: '', lastAt: 0 };
}

export function hardwareCaptureAllowedTarget(target) {
  if (!target) return true;
  const tag = String(target.tagName || '').toUpperCase();
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(tag)) return false;
  return !target.isContentEditable;
}

export function consumeHardwareScannerKey(state, key, now = Date.now(), options = {}) {
  const current = state && typeof state === 'object' ? state : createHardwareScanState();
  const maxGapMs = Math.max(20, Number(options.maxGapMs) || HARDWARE_SCAN_MAX_GAP_MS);
  const minLength = Math.max(1, Number(options.minLength) || HARDWARE_SCAN_MIN_LENGTH);
  const rawKey = String(key || '');
  const textKey = rawKey === 'GroupSeparator' ? '\u001D' : rawKey;

  if (textKey === 'Enter' || textKey === 'Tab') {
    const barcode = current.buffer.length >= minLength ? current.buffer : '';
    return {
      state: createHardwareScanState(),
      barcode,
      consumed: Boolean(current.buffer),
      terminal: true,
    };
  }

  if (textKey.length !== 1) {
    return { state: current, barcode: '', consumed: false, terminal: false };
  }

  const stale = current.lastAt > 0 && now - current.lastAt > maxGapMs;
  const buffer = `${stale ? '' : current.buffer}${textKey}`;
  return {
    state: { buffer, lastAt: now },
    barcode: '',
    consumed: true,
    terminal: false,
  };
}

export function commitIdleHardwareScan(state, minLength = HARDWARE_SCAN_MIN_LENGTH) {
  const current = state && typeof state === 'object' ? state : createHardwareScanState();
  return {
    state: createHardwareScanState(),
    barcode: current.buffer.length >= Math.max(1, Number(minLength) || HARDWARE_SCAN_MIN_LENGTH) ? current.buffer : '',
  };
}
